interface EditChoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectClinicalChart: () => void;
  onSelectSales: () => void;
}

export const EditChoiceModal = ({
  isOpen,
  onClose,
  onSelectClinicalChart,
  onSelectSales,
}: EditChoiceModalProps) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-gray-900/60 backdrop-blur-sm"
      onClick={handleBackdropClick}
    >
      <div className="w-full max-w-[420px] bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden animate-in fade-in zoom-in duration-200">
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
          <h3 className="text-xl font-bold text-[#101822] tracking-tight">
            ¿Qué deseas editar?
          </h3>
          <button
            onClick={onClose}
            className="p-1.5 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100 transition-colors"
          >
            <span className="material-symbols-outlined text-xl">close</span>
          </button>
        </div>
        <div className="p-6 flex flex-col gap-4">
          <button
            onClick={onSelectClinicalChart}
            className="group relative flex items-center w-full gap-5 p-4 rounded-xl border border-gray-200 bg-white hover:border-primary hover:bg-blue-50/60 transition-all text-left shadow-sm hover:shadow-md hover:-translate-y-0.5"
          >
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-blue-100 text-2xl group-hover:bg-white transition-colors">
              🩺
            </div>
            <div className="flex flex-col gap-0.5">
              <span className="text-lg font-bold text-[#101822] group-hover:text-primary transition-colors">
                Ficha Clínica
              </span>
              <span className="text-sm font-medium text-gray-500">
                Ir a Medical Chart
              </span>
            </div>
            <div className="ml-auto text-gray-300 group-hover:text-primary transition-colors">
              <span className="material-symbols-outlined">arrow_forward_ios</span>
            </div>
          </button>
          <button
            onClick={onSelectSales}
            className="group relative flex items-center w-full gap-5 p-4 rounded-xl border border-gray-200 bg-white hover:border-[#F59E0B] hover:bg-amber-50/60 transition-all text-left shadow-sm hover:shadow-md hover:-translate-y-0.5"
          >
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-amber-100 text-2xl group-hover:bg-white transition-colors">
              👓
            </div>
            <div className="flex flex-col gap-0.5">
              <span className="text-lg font-bold text-[#101822] group-hover:text-[#F59E0B] transition-colors">
                Venta y Aros
              </span>
              <span className="text-sm font-medium text-gray-500">
                Ir a Sales Screen
              </span>
            </div>
            <div className="ml-auto text-gray-300 group-hover:text-[#F59E0B] transition-colors">
              <span className="material-symbols-outlined">arrow_forward_ios</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};
